import { render, staticRenderFns } from "./publicList.vue?vue&type=template&id=5390eb46&scoped=true&"
import script from "./publicList.vue?vue&type=script&lang=js&"
export * from "./publicList.vue?vue&type=script&lang=js&"
import style0 from "./publicList.vue?vue&type=style&index=0&id=5390eb46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5390eb46",
  null
  
)

export default component.exports